import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QrCodeRecord } from './app.types';

@Component({
  selector: 'app-qr-history',
  standalone: false,
  template: `
    <section class="history" *ngIf="visible">
      <div class="history-header">
        <h2>Your QR Codes</h2>
      </div>

      <div class="qr-history-controls">
        <label class="sr-only" for="qr-history-search">Search QR codes</label>
        <input
          id="qr-history-search"
          class="qr-history-search"
          type="search"
          [value]="searchQuery"
          placeholder="Search QR codes"
          (input)="emitSearch($event)"
        />
      </div>

      <ion-note color="medium" *ngIf="isLoading">Loading QR codes...</ion-note>
      <ion-note color="medium" *ngIf="!isLoading && qrCodes.length === 0">No tracked QR codes yet.</ion-note>

      <div class="qr-list" *ngIf="qrCodes.length > 0">
        <div
          class="qr-list-item qr-history-item"
          *ngFor="let qrCode of qrCodes"
          [class.active]="selectedQrCodeId === qrCode.id"
        >
          <button type="button" class="qr-list-main" (click)="selectQrCode.emit(qrCode)">
            <span class="qr-title">{{ qrCode.title || qrCode.redirect_path }}</span>
            <span class="qr-target">{{ qrCode.target_url }}</span>
            <span class="qr-meta">{{ qrCode.redirect_path }} · {{ qrCode.scan_count }} scans</span>
          </button>
          <span class="qr-actions">
            <button
              type="button"
              class="qr-inline-action"
              [disabled]="editingId === qrCode.id"
              (click)="editQrCode.emit(qrCode)"
            >
              {{ editingId === qrCode.id ? 'Saving...' : 'Edit details' }}
            </button>
            <button
              type="button"
              class="qr-inline-action danger"
              [disabled]="deletingId === qrCode.id"
              (click)="deleteQrCode.emit(qrCode)"
            >
              {{ deletingId === qrCode.id ? 'Deleting...' : 'Delete' }}
            </button>
          </span>
        </div>
      </div>

      <div class="qr-pagination" *ngIf="totalPages > 1">
        <button type="button" class="qr-inline-action" [disabled]="isLoading || page <= 1" (click)="pageChange.emit(page - 1)">
          Previous
        </button>
        <span class="qr-page-status">Page {{ page }} of {{ totalPages }} · {{ totalCount }} QR codes</span>
        <button type="button" class="qr-inline-action" [disabled]="isLoading || page >= totalPages" (click)="pageChange.emit(page + 1)">
          Next
        </button>
      </div>
    </section>
  `
})
export class QrHistoryComponent {
  @Input() visible = false;
  @Input() qrCodes: QrCodeRecord[] = [];
  @Input() selectedQrCodeId: number | null = null;
  @Input() editingId: number | null = null;
  @Input() deletingId: number | null = null;
  @Input() isLoading = false;
  @Input() searchQuery = '';
  @Input() page = 1;
  @Input() totalPages = 1;
  @Input() totalCount = 0;

  @Output() selectQrCode = new EventEmitter<QrCodeRecord>();
  @Output() editQrCode = new EventEmitter<QrCodeRecord>();
  @Output() deleteQrCode = new EventEmitter<QrCodeRecord>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() pageChange = new EventEmitter<number>();

  emitSearch(event: Event): void {
    this.searchChange.emit((event.target as HTMLInputElement).value);
  }
}
